export const permissions = {
  studentsRead: 'students.read',
  studentsPersonalRead: 'students.personal.read',
  studentsWrite: 'students.write',
  staffRead: 'staff.read',
  staffWrite: 'staff.write',
  catalogRead: 'catalog.read',
  catalogWrite: 'catalog.write',
  schedulingRead: 'scheduling.read',
  schedulingWrite: 'scheduling.write',
  schedulingAttendance: 'scheduling.attendance',
  classroomRecordingsRead: 'classroom.recordings.read',
  learningRead: 'learning.read',
  learningWrite: 'learning.write',
  reviewsRead: 'reviews.read',
  reviewsWrite: 'reviews.write',
  subscriptionsRead: 'subscriptions.read',
  subscriptionsWrite: 'subscriptions.write',
  billingRead: 'billing.read',
  billingWrite: 'billing.write',
  payrollRead: 'payroll.read',
  payrollWrite: 'payroll.write',
  crmRead: 'crm.read',
  crmWrite: 'crm.write',
  messagesRead: 'messages.read',
  messagesWrite: 'messages.write',
  messagesSupportAuthorsRead: 'messages.support.authors.read',
  messagesAuthorsRead: 'messages.authors.read',
  teachingChatsRead: 'messages.teaching.read',
  campaignsRead: 'campaigns.read',
  campaignsWrite: 'campaigns.write',
  campaignsSend: 'campaigns.send',
  settingsRead: 'settings.read',
  settingsWrite: 'settings.write',
  importsRead: 'imports.read',
  accountsManage: 'accounts.manage',
  portalPreview: 'portal.preview',
} as const

export const landingLeadReadPermissions = [permissions.studentsRead, permissions.studentsPersonalRead] as const

interface RoutePermissionRule {
  prefix: string
  read: string
  write?: string
}

const routePermissionRules: RoutePermissionRule[] = [
  { prefix: '/leads', read: permissions.studentsRead, write: permissions.studentsWrite },
  { prefix: '/students', read: permissions.studentsRead, write: permissions.studentsWrite },
  { prefix: '/teachers', read: permissions.staffRead, write: permissions.staffWrite },
  { prefix: '/staff', read: permissions.staffRead, write: permissions.staffWrite },
  { prefix: '/catalog', read: permissions.catalogRead, write: permissions.catalogWrite },
  { prefix: '/registrations', read: permissions.catalogRead, write: permissions.catalogWrite },
  { prefix: '/calendar', read: permissions.schedulingRead, write: permissions.schedulingWrite },
  { prefix: '/lessons', read: permissions.schedulingRead, write: permissions.schedulingWrite },
  { prefix: '/classroom', read: permissions.classroomRecordingsRead },
  { prefix: '/lesson-schedules', read: permissions.schedulingRead, write: permissions.schedulingWrite },
  { prefix: '/learning', read: permissions.learningRead, write: permissions.learningWrite },
  { prefix: '/student-reviews', read: permissions.reviewsRead, write: permissions.reviewsWrite },
  { prefix: '/review-forms', read: permissions.reviewsRead, write: permissions.reviewsWrite },
  { prefix: '/review-form-responses', read: permissions.reviewsRead, write: permissions.reviewsWrite },
  { prefix: '/subscriptions', read: permissions.subscriptionsRead, write: permissions.subscriptionsWrite },
  { prefix: '/billing', read: permissions.billingRead, write: permissions.billingWrite },
  { prefix: '/payroll', read: permissions.payrollRead, write: permissions.payrollWrite },
  { prefix: '/crm', read: permissions.crmRead, write: permissions.crmWrite },
  { prefix: '/communications/client-work', read: permissions.crmRead, write: permissions.crmWrite },
  { prefix: '/communications/campaigns', read: permissions.campaignsRead, write: permissions.campaignsWrite },
  { prefix: '/communications/teaching-chats', read: permissions.teachingChatsRead },
  { prefix: '/communications', read: permissions.messagesRead, write: permissions.messagesWrite },
  { prefix: '/messages', read: permissions.messagesRead, write: permissions.messagesWrite },
  { prefix: '/settings', read: permissions.settingsRead, write: permissions.settingsWrite },
]

function rule(path: string): RoutePermissionRule | undefined {
  return routePermissionRules.find(item => path === item.prefix || path.startsWith(`${item.prefix}/`))
}

export function routeReadPermission(path: string): string | undefined {
  return rule(path)?.read
}

export function routeWritePermission(path: string): string | undefined {
  return rule(path)?.write
}

export const roleLabels: Record<string, string> = {
  owner: 'Суперпользователь',
  senior_teacher: 'Старший преподаватель',
  manager: 'Менеджер',
  teamleader: 'Тимлидер',
  student: 'Ученик',
  parent: 'Родитель',
  teacher: 'Преподаватель',
}

export const portalRoleCodes = new Set(['student', 'parent', 'teacher'])
